import { render, staticRenderFns } from "./myPoints.vue?vue&type=template&id=4ce3b86d&scoped=true&"
import script from "./myPoints.vue?vue&type=script&lang=js&"
export * from "./myPoints.vue?vue&type=script&lang=js&"
import style0 from "./myPoints.vue?vue&type=style&index=0&id=4ce3b86d&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ce3b86d",
  null
  
)

export default component.exports